export default __webpack_public_path__ + "static/media/CamsImg.17f50bab.jpg";